import { combineReducers } from 'redux';
import * as c from '../constants/constant_action_types';

const LIST_INITIAL_STATE = {
  table_rows: [],
  table_rows_count: 0,
  isFetching: false,
};

const LIST_OPTIONS_INIT_STATE = {
  pagination: {
    page: 1,
    perPage: 10,
  },
  sortingColumns: {},
};

function listReducer(state = LIST_INITIAL_STATE, action) {
  switch (action.type) {
    case c.FETCH_SYSTEM_NOTES_INPROGRESS: {
      return {
        ...state,
        isFetching: true,
      };
    }

    case c.FETCH_SYSTEM_NOTES_DONE: {
      return {
        ...state,
        table_rows: action.payload.rows,
        table_rows_count: action.payload.total_rows,
        isFetching: false,
      };
    }

    case c.FETCH_SYSTEM_NOTES_ERROR: {
      const { error } = action;
      return {
        error: error,
      };
    }

    default:
      return state;
  }
}

function listOptionsReducer(state = LIST_OPTIONS_INIT_STATE, action) {
  const { type, options } = action;
  switch (type) {
    case 'SET_SYSTEM_NOTES_OPTIONS':
      return {
        ...state,
        pagination: options.pagination,
        sortingColumns: options.sortingColumns,
      };
    default:
      return state;
  }
}

export const systemNotesReducer = combineReducers({
  data: listReducer,
  options: listOptionsReducer,
});
